import React from "react";
import Pesquisa from "./Pesquisa/Pesquisa";

function Menu({ dados, aoPesquisar }) {
  const secoes = [
    { titulo: "Realidade Virtual", id: "secao-rv" },
    { titulo: "Realidade Aumentada", id: "secao-ra" },
    { titulo: "Vídeo 360", id: "secao-video360" },
    { titulo: "Vídeo 360i", id: "secao-video360i" },
  ];

  const irParaSecao = (id) => {
    const elemento = document.getElementById(id);
    if (elemento) elemento.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="menu">
      {secoes.map((sec) => (
        <button key={sec.id} onClick={() => irParaSecao(sec.id)}>
          {sec.titulo}
        </button>
      ))}
      <Pesquisa dados={dados} aoPesquisar={aoPesquisar} />
    </nav>
  );
}

export default Menu;
